// extracted by mini-css-extract-plugin
export default {"wrapper":"RoleSelect_wrapper__Vnu7d","heading":"RoleSelect_heading__sA5A3","continueBtn":"RoleSelect_continueBtn__dYw7j","disabled":"RoleSelect_disabled__sYJm8"};